import {useParams} from 'react-router-dom';

import {Grid} from '@mantine/core';

import {
    FormPageLayout,
    PlatformLoader,
    SimplePageContentWrapper,
} from '@flexinet/ui-components';
import {Profile} from '../profile/Profile';

import {EditPageNavigation} from '../navigation/EditPageNavigation';
import {useProduct} from '../hooks/useProduct';
import {useEditPageTools} from '../hooks/useEditPageTools';
import {FormDrawer} from '../drawers/FormDrawer';
import {IndexPage as PricesIndexPage} from '../../prices/pages/IndexPage';

export const EditPage = () => {

    const {id: componentId} = useParams();

    if (typeof componentId === 'undefined') {
        throw new Error('componentId is required parameter');
    }

    const {
        record: component,
        loading,
        updateRecord,
    } = useProduct(componentId);

    const {
        drawerOpened,
        setDrawerOpened,
        tools,
    } = useEditPageTools();

    if (loading || !component) {
        return <PlatformLoader message='Loading application...Please wait'/>;
    }


    return (
        <FormPageLayout
            title={component.name ? component.name : component.id}
            pageNavigation={<EditPageNavigation component={component}/>}
            tools={tools}
        >

            <Grid>
                <Grid.Col span={{
                    base: 12,
                    lg: 4
                }}>
                    <Profile record={component}/>
                </Grid.Col>
                <Grid.Col span={{
                    base: 12,
                    lg: 8
                }}>
                    <SimplePageContentWrapper>
                        <PricesIndexPage/>
                    </SimplePageContentWrapper>
                </Grid.Col>
            </Grid>

            <FormDrawer
                record={component}
                handleSubmit={updateRecord}
                opened={drawerOpened}
                onClose={() => setDrawerOpened(false)}
            />

        </FormPageLayout>
    );
};
